import { Grid, Typography } from '@mui/material'
import React from 'react'
import { useUser } from '../../hooks/useUser'
import { documents } from '../../utils/accept'
import { BrandSelect } from '../BrandsSelect/BrandSelect'
import { ControlledChipInput } from '../ControlledChipInput'
import { ControlledFileInput } from '../ControlledFileInput'
import { ControlledTextField } from '../ControlledTextField'
import { FieldContainer } from '../FieldContainer'
import { RangeSelect } from '../RegisterInfluencerForm/RangeSelect'
import { CampaignTypeSelect } from './CampaignTypeSelect'
import { PlatformCheckboxes } from './PlatformCheckboxes'
import { RegionCheckboxes } from './RegionCheckboxes'
import { VerticalCheckboxes } from './VerticalCheckboxes'

export const CampaignFields = ({
  showTitle = false,
  isEditing,
  briefInitial,
  verticalInitial,
  platformInitial,
  regionInitial,
  minAgeInitial,
  maxAgeInitial
}) => {
  const { isAdmin } = useUser()
  return (
    <FieldContainer>
      <Grid container spacing={2}>
        {showTitle && (
          <Grid item xs={12}>
            <Typography variant='h6'>Campaign</Typography>
          </Grid>
        )}
        {isAdmin && !isEditing && (
          <Grid item xs={12}>
            <BrandSelect disabled={isEditing} />
          </Grid>
        )}
        <Grid item xs={12}>
          <ControlledTextField name='campaign.name' label='Name' />
        </Grid>
        <Grid item xs={12}>
          <ControlledChipInput
            name='campaign.hashTags'
            label='Hashtags'
            prefix='#'
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CampaignTypeSelect />
        </Grid>
        <Grid item xs={12}>
          <ControlledFileInput
            name='brief'
            label='Already have a brief ready?'
            initial={isEditing ? briefInitial : undefined}
            accept={documents}
          />
        </Grid>
        <Grid item>
          <VerticalCheckboxes
            initialValues={isEditing ? verticalInitial : undefined}
            min={0}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name='campaign.about'
            label='Tell us more about the campaign.'
            placeholder='What makes the it revolutionary? What do you want the influencers to talk about?'
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name='campaign.targetMarket'
            label={`What's the target market like?`}
            placeholder='Demographics & Psychographics'
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name='campaign.goals'
            label='What are the goals / objectives of this campaign?'
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <RangeSelect name='rangeOfFollowers' />
        </Grid>
        <Grid item xs={12} md={3}>
          <ControlledTextField
            name='minAge'
            label='Minimum Age'
            defaultValue={minAgeInitial ?? 0}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <ControlledTextField
            name='maxAge'
            label='Maximum Age'
            defaultValue={maxAgeInitial ?? 100}
          />
        </Grid>
        <Grid item xs={12}>
          <PlatformCheckboxes initialValues={platformInitial} />
        </Grid>
        <Grid item xs={12}>
          <RegionCheckboxes initialValues={regionInitial} />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name='campaign.influencers'
            label='Describe the influencer/s you would like to engage.'
            placeholder='(i.e. number of following, interests, etc.)'
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name='campaign.influencerScope'
            label='What scope of work would you want these influencers to do?'
            placeholder='Please specify platforms of interest, type of content, and maybe even frequency/quantity of placements.'
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledChipInput
            name='campaign.urls'
            label='URL/s of posts from previous campaigns (max 3 URLs)'
            max={3}
          />
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
